<template>
    <div class="chat-container">
      <div class="chat-messages">
        <div v-for="(message, index) in messages" :key="index" :class="{'user-message': message.sender === 'user', 'bot-message': message.sender === 'bot'}">
          {{ message.text }}
        </div>
      </div>
  
      <div class="input-area">
        <speech-input v-model="newMessage" />
        <button @click="sendMessage" :disabled="!newMessage.trim()">Enviar</button>
      </div>
    </div>
  </template>
  
  <script>
  import SpeechInput from './SpeechInput.vue';
  import { ref } from 'vue';
  
  export default {
    components: {
      SpeechInput,
    },
    setup() {
      const messages = ref([]);
      const newMessage = ref('');
      const synth = window.speechSynthesis;
      let voices = [];
  
      if (synth) {
        synth.onvoiceschanged = () => {
          voices = synth.getVoices();
          console.log("Voces disponibles:", voices);
        };
      }
  
      const speak = (text) => {
        if (!synth) {
          console.warn("API de Síntesis de voz no disponible");
          return;
        }
  
        const utterance = new SpeechSynthesisUtterance(text);
        utterance.lang = 'es-ES';
  
        const selectedVoice = voices.find(voice => voice.lang === 'es-ES');
        if (selectedVoice) {
          utterance.voice = selectedVoice;
        } else {
          console.warn('No se encontró la voz es-ES');
        }
  
        utterance.onend = () => {
          console.log('Lectura finalizada');
        };
        utterance.onerror = (event) => {
          console.error('Error en la síntesis de voz', event.error);
        };
        synth.speak(utterance);
      };
  
      const sendMessage = () => {
        if (newMessage.value.trim()) {
          const userMessage = newMessage.value;
          messages.value.push({ text: userMessage, sender: 'user' });
  
          const botResponse = `Eco: ${userMessage}`;
          messages.value.push({ text: botResponse, sender: 'bot' });
          speak(botResponse);
          newMessage.value = '';
        }
      };
  
      return { messages, newMessage, sendMessage };
    },
    watch: {
      messages: {
        handler(newMessages) {
          const lastMessage = newMessages[newMessages.length - 1];
          if (lastMessage?.sender === 'bot') {
            console.log('Último mensaje del bot:', lastMessage);
          }
        },
        deep: true,
      },
    },
  };
  </script>
  
  <style scoped>
  .chat-container {
    display: flex;
    flex-direction: column;
    height: auto;
    border: 1px solid #ccc;
    padding: 10px;
    overflow-y: auto;
    width: auto;
  }
  .chat-messages {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
  }
  .user-message,
  .bot-message {
    padding: 8px;
    margin-bottom: 5px;
    border-radius: 8px;
    max-width: 70%;
    word-wrap: break-word;
  }
  
  .user-message {
    align-self: flex-end;
    background-color: #e1f5fe;
  }
  
  .bot-message {
    align-self: flex-start;
    background-color: #f0f0f0;
  }
  
  .input-area {
    display: flex;
    margin-top: 10px;
  }
  .input-area textarea {
    flex-grow: 1;
    padding: 8px;
    border: 1px solid #ddd;
    border-radius: 4px;
    min-height: 100px;
  }
  .input-area button {
    background-color: #4caf50;
    color: white;
    border: none;
    padding: 10px 15px;
    border-radius: 4px;
    cursor: pointer;
    margin-left: 10px;
  }
  .input-area button:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }
  </style>